export const saleTransitions: Record<string, string[]> = {
  draft: ['booked', 'confirmed', 'delivery_pending', 'delivered', 'cancelled'],
  booked: ['confirmed', 'delivery_pending', 'delivered', 'cancelled'],
  confirmed: ['booked', 'delivery_pending', 'delivered', 'cancelled'],
  delivery_pending: ['confirmed', 'delivered', 'cancelled'],
  delivered: ['delivery_pending'],
};

export function allowedSaleTransitions(status: string, role?: string | null) {
  if (status === 'delivered' && !['owner', 'admin'].includes(role ?? '')) return [];
  return saleTransitions[status] ?? [];
}

export const canCollectSalePayment = (status: string) =>
  ['booked', 'confirmed', 'delivery_pending', 'delivered', 'partially_returned'].includes(status);
